import { ProgressBar } from "@adeccoux/tag-ds";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { TEST_COMPLETE, TEST_QUESTIONS } from "../../util/constants";
import { getNoCacheCall, postCall } from "../../util/resources";
import SesHeader from "../header";
import {
    CommonLoader,
    CommonPopup,
    useTT70Timer,
    QuestionCommonPopup,
    CommonQuesProgress,
    QuesLoader,
    useScreenTransition,
    redirectToAssessmentSummary,
    useTimerValues,
} from "../../util/common";
import { BaseContext } from "../../App";
import { v4 as uuidv4 } from "uuid";
import WarmupComplete from "../instructions/warmupComplete";

const TestTaker70 = () => {
    const [test, setTest] = useState();
    const [questionImage, setQuestionImage] = useState();
    const [selectedAns, setSelectedAns] = useState(-1);
    const [popupData, setpopupData] = useState({
        isOpen: false,
        popupHeader: "",
        popupBody: "",
        popupFooter: "",
    });
    const [qpopupData, setQpopupData] = useState({
        isOpen: false,
        popupHeader: "",
        popupBody: "",
        popupFooter: "",
    });
    const [textanswer, settextanswer] = useState("");
    const { min, sec, totalSecLeft, startTimer, stopTimer } = useTT70Timer();
    const location = useLocation();
    const { isWarmupDoneShown, setWarmupDoneShown } = useContext(BaseContext);
    const { phase, loading, startTransition, done } = useScreenTransition();

    const phrases = location.state.user.siteConfig.phrases;
    const navigate = useNavigate();
    const qattempts = useRef(0);
    const [isMultiChoice, setIsMultiChoice] = useState(false);
    const [isOpenText, setIsOpenText] = useState(false);
    const formRef = useRef();
    const [originalAns, setOriginalAns] = useState([]);
    const exampleTest = useRef();
    const quesNo = useRef(-1);
    const [questionData, setQuestionData] = useState({});
    const timerStarted = useRef(false);
    const stepRef = useRef();
    const attachKeyListenRef = useRef();
    const keyMappings = useRef({});
    const header = useRef({
        "x-xpert-session": location.state.user.sessionId,
        "Content-Type": "application/json",
    });
    const { timerOverallAssessment } = useTimerValues();

    const [disablednext, setdisablednext] = useState(true);
    const buildMediaUrl = (file) => {
        let builtUrl =
            window.location.protocol +
            "//" +
            window.location.hostname +
            "/static";
        builtUrl += (file.startsWith("/") ? "" : "/") + file;
        return builtUrl;
    };

    const nextNavigate = async (action) => {
        startTransition(async () => {
            if (location.state.warmUp) {
                validateAnsw(
                    textanswer,
                    exampleTest.current[quesNo.current - 1]
                );
            } else {
                const elapsedTime = stopTimer();
                let finalAnsData;
                let finalVal = null;
                if (isMultiChoice) {
                    let multiChoiceAns = test.questions[0].answers;
                    for (let i = 0; i < multiChoiceAns.length; i++) {
                        let currentAns = multiChoiceAns[i];
                        if (currentAns.selected) {
                            finalVal += Math.pow(2, i);
                        }
                    }
                    finalAnsData = finalVal;
                } else {
                    finalAnsData = textanswer;
                }

                const ansObj = {
                    answers: [],
                    structure: null,
                    value: finalAnsData?.toString(),
                };
                let quesObj = test.questions;
                quesObj[0].userAnswer = ansObj;
                quesObj[0].answers = originalAns;
                const otherData = {
                    duration: location.state.test.duration + elapsedTime,
                    fwdtimes: "",
                    instrumentType: "",
                    pause: "",
                    playTimes: "",
                    rwdTimes: "",
                };
                try {
                    let response;
                    if (action === "timeEnded") {
                        test.lastPage = true;
                    }
                    if (test.lastPage) {
                        stopTimer();
                        response = await postCall(
                            TEST_COMPLETE + location.state.test.id,
                            { ...otherData, questions: quesObj },
                            header.current
                        );
                    } else {
                        response = await postCall(
                            TEST_QUESTIONS + location.state.test.id,
                            { ...otherData, questions: quesObj },
                            header.current
                        );
                    }
                    if (response.data.status === true) {
                        if (test.lastPage) {
                            redirectToAssessmentSummary(location, navigate);
                        } else {
                            setSelectedAns("");
                            formRef.current.reset();
                            quesNo.current += 1;
                            await getQuestion();
                        }
                    }
                } catch (error) {
                    console.log(error);
                }
            }
            done();
        });
    };
    const [rightAns, setrightAns] = useState(false);
    const validateAnsw = (selAns, question) => {
        if (!rightAns) {
            let currectAns = false;
            let currectAnsVal = [];

            for (let i = 0; i < question.questions[0].answers.length; i++) {
                if (question.questions[0].answers[i].score == 1) {
                    currectAnsVal.push(question.questions[0].answers[i]);
                    if (isMultiChoice) {
                        if (question.questions[0].answers[i].selected) {
                            currectAns = true;
                        } else {
                            currectAns = false;
                        }
                    } else {
                        if (
                            question.questions[0].answers[i].content == selAns
                        ) {
                            currectAns = true;
                        } else {
                            currectAns = false;
                        }
                    }
                }
            }

            let message;

            if (currectAns) {
                setrightAns(true);
                message = phrases?.["15145"];
            } else {
                switch (qattempts.current) {
                    case 0:
                        message = phrases?.["15146"];
                        qattempts.current = qattempts.current + 1;
                        break;
                    case 1:
                        message = phrases?.["15147"];
                        qattempts.current = qattempts.current + 1;
                        break;

                    default:
                        message =
                            phrases?.["15148"] +
                            "<br>" +
                            currectAnsVal.map((val, index) => val.content) +
                            phrases?.["15149"];
                        message = String(message);
                        qattempts.current = qattempts.current + 1;
                        break;
                }
            }
            message = message.split("\\n").join("<br />");
            message =
                `<span style="font-size: medium;vertical-align: text-top;padding-right: 5px;" class="material-icons ${currectAns ? "icon-success" : "icon-error"
                }">${currectAns ? "check_circle" : "info"}</span>` + message;

            setQpopupData((prev) => {
                prev = {
                    ...prev,
                    isOpen: true,
                    popupHeader: phrases?.["10980"],
                    popupBody: message,
                    popupFooter: phrases?.["10928"],
                };
                return prev;
            });
        } else {
            setrightAns(false);
            if (test.lastPage) {
                stopTimer();
                setWarmupDoneShown(true);
            } else {
                qattempts.current = 0;
                getQuestion();
            }
        }
    };

    const handleMultiChoiceData = async (data) => {
        const newData = Object.assign({}, data);
        let userAnswer = "";
        await processAnswers(newData?.answers);
        if (newData.userAnswer) {
            if (
                newData.userAnswer.value &&
                newData.userAnswer.value.toString() !== "-1"
            ) {
                userAnswer = newData.userAnswer.value.split("#$#");
                let userChoice = parseInt(userAnswer[0], 10);
                for (let i = 0; i < newData.answers.length; i++) {
                    if (userChoice & Math.pow(2, i) && userChoice !== -1) {
                        newData.answers[i].selected = true;
                    } else {
                        newData.answers[i].selected = false;
                    }
                }
                return newData.answers;
            } else {
                return data.answers;
            }
        } else {
            return data.answers;
        }
    };

    const processAnswers = (data) => {
        let count = 0;
        data.map((val) => {
            if (val.selected) {
                count++;
            }
        });
        if (count > 0) {
            setdisablednext(false);
        } else {
            setdisablednext(true);
        }
    };

    const changeMultiSelectedAns = (multiData, index) => {
        var tempData = { ...multiData };
        if (tempData.selected) {
            tempData.selected = false;
        } else {
            tempData.selected = true;
        }

        setQuestionData({
            ...questionData,
            ...(questionData.answers[index] = tempData),
        });
        processAnswers(questionData.answers);
    };

    const getQuestion = async () => {
        setdisablednext(true);
        let key;
        if (location.state.warmUp) {
            if (
                exampleTest.current[
                    quesNo.current
                ].questions[0].answers[0].groupId.toString() === "2"
            ) {
                setIsMultiChoice(true);
                setIsOpenText(false);
                keyMappings.current = {};
                exampleTest.current[quesNo.current].questions[0].answers?.map(
                    (val) => {
                        key = `Digit${val.position + 1}`;
                        keyMappings.current = {
                            ...keyMappings.current,
                            [key]: val.position,
                        };
                    }
                );
            } else {
                setIsOpenText(true);
                setIsMultiChoice(false);
                if (
                    exampleTest.current[quesNo.current].questions[0]
                        .userAnswer !== null
                ) {
                    settextanswer(
                        exampleTest.current[quesNo.current].questions[0]
                            .userAnswer.value
                    );
                    setdisablednext(false);
                }
            }
            setTest(exampleTest.current[quesNo.current]);
            const deepClone = JSON.parse(
                JSON.stringify(
                    exampleTest.current[quesNo.current].questions[0].answers
                )
            );
            setOriginalAns(deepClone);
            await handleMultiChoiceData(
                exampleTest.current[quesNo.current].questions[0]
            ).then((finalData) => {
                setQuestionData({ answers: finalData });
            });
            quesNo.current += 1;
        } else {
            try {
                const response = await getNoCacheCall(
                    TEST_QUESTIONS +
                    location.state.test.id +
                    "/" +
                    quesNo.current,
                    header.current
                );
                setTest(response.data[0]);
                setIsMultiChoice(
                    response.data[0].questions[0].answers[0].groupId.toString() ===
                        "2"
                        ? true
                        : false
                );
                setIsOpenText(
                    response.data[0].questions[0].answers[0].groupId.toString() ===
                        "3"
                        ? true
                        : false
                );

                quesNo.current = response.data[0].startNumber;
                keyMappings.current = {};
                response.data[0].questions[0].answers.map((val) => {
                    key = `Digit${val.position + 1}`;
                    keyMappings.current = {
                        ...keyMappings.current,
                        [key]: val.position,
                    };
                });

                if (
                    response.data[0].questions[0].answers[0].groupId.toString() ===
                    "2"
                ) {
                    const deepClone = JSON.parse(
                        JSON.stringify(response.data[0].questions[0].answers)
                    );
                    setOriginalAns(deepClone);
                    await handleMultiChoiceData(
                        response.data[0].questions[0]
                    ).then((finalData) => {
                        setQuestionData({ answers: finalData });
                    });
                }
                settextanswer("");
                if (!timerStarted.current) {
                    startTimer(
                        location.state.test.timeLimit -
                        location.state.test.duration
                    );
                    timerStarted.current = true;
                } else {
                    startTimer();
                }
            } catch (error) {
                console.log();
            }
        }
    };

    const setExampleAns = (selectedAns) => {
        if (location.state.warmUp && quesNo.current !== -1) {
            let quesObj =
                location.state.test.testExample[quesNo.current - 1]?.questions;
            const ansObj = {
                answers: [],
                structure: null,
                value: selectedAns,
            };
            quesObj[0].userAnswer = ansObj;
        }
    };

    const handleChange = (event) => {
        const value = event.target.value;
        if (value === null || value === "" || value === undefined) {
            setdisablednext(true);
        } else {
            setdisablednext(false);
        }
        setExampleAns(value);
        settextanswer(value);
    };
    const exitTest = () => {
        if (location.state.warmUp) {
            navigate("/instructions", {
                state: { ...location.state, warmUp: false },
            });
        } else {
            setpopupData((prev) => {
                prev = {
                    ...prev,
                    isOpen: true,
                    popupHeader: location.state.test.name,
                    popupBody: phrases?.["1002189"],
                    popupFooter: phrases?.["14392"],
                };
                return prev;
            });
        }
    };

    const closePopUp = () => {
        setpopupData((prev) => {
            prev = { ...prev, isOpen: false };
            return prev;
        });
        stopTimer();
        navigate("/");
    };

    const qclosePopUp = () => {
        setQpopupData((prev) => {
            prev = { ...prev, isOpen: false };
            return prev;
        });
    };

    const qapproveAction = () => {
        setQpopupData((prev) => {
            prev = { ...prev, isOpen: false };
            return prev;
        });
    };

    const changeSelectedAns = (e) => {
        setSelectedAns(e.target.value);
    };

    const approveAction = async () => {
        stopTimer();
        test.lastPage = true;
        nextNavigate();
    };

    useEffect(() => {
        attachKeyListenRef.current?.focus({
            preventScroll: true,
        });
    }, [test]);
    const detectKeyDown = (e) => {
        e.preventDefault();
        if (!loading && !qpopupData?.isOpen) {
            if (isMultiChoice) {
                if (e.code in keyMappings.current) {
                    setQuestionData({
                        ...questionData,
                        ...(questionData.answers[
                            keyMappings.current[e.code]
                        ].selected =
                            !questionData.answers[keyMappings.current[e.code]]
                                .selected),
                    });
                    processAnswers(questionData.answers);
                }
            }
            if (!disablednext && e.code === "Space") {
                nextNavigate();
            }
        } else if (qpopupData?.isOpen && e.code === "Space") {
            qapproveAction();
        }
    };

    const handleMainTestStart = () => {
        location.state.warmUp = false;
        location.state.samplesCompleted = true;
        quesNo.current = -1;
        getQuestion();
    };

    useEffect(() => {
        if (totalSecLeft === 0) {
            nextNavigate("timeEnded");
        }
        if (test) {
            stepRef?.current?.children[1]?.children[0]?.setAttribute(
                "data-secLeft",
                `${min}:${sec}`
            );
        }
    }, [totalSecLeft]);

    useEffect(() => {
        if (location.state.warmUp) {
            exampleTest.current = location.state.test.testExample;
            quesNo.current = 0;
        }
        getQuestion();
    }, []);

    if (!test) {
        return <CommonLoader />;
    }

    if (isWarmupDoneShown) {
        return (
            <WarmupComplete
                backtoInst={exitTest}
                handleMainTestStart={handleMainTestStart}
            />
        );
    }

    return (
        <>
            <div
                className="g-container flex_col p4 g5 pt0_mobile g2_mobile full-width"
                ref={attachKeyListenRef}
                tabIndex="-1"
                onKeyDown={detectKeyDown}
                style={{ outline: "none" }}
            >
                <SesHeader clientCobranding={location.state.cobrandingLink} />
                <div
                    ref={stepRef}
                    className="top-progress-container flex_row sticky full-width g3"
                >
                    <CommonQuesProgress test={test} />
                    {!location.state.warmUp && (
                        <ProgressBar
                            circular
                            step={totalSecLeft}
                            steps={location.state.test.timeLimit}
                            circularColorClass={
                                timerOverallAssessment !== undefined &&
                                    totalSecLeft <= timerOverallAssessment
                                    ? "progress-bar-color"
                                    : ""
                            }
                        />
                    )}
                </div>

                <div className="flex_col g2">
                    <h3>
                        {location.state.warmUp
                            ? location.state.test.testExampleName
                            : location.state.test.name}
                    </h3>
                    <div
                        className="base questionText"
                        dangerouslySetInnerHTML={{
                            __html: test.questions[0].topicInstruction,
                        }}
                    />
                </div>
                <div className=" position_relative ">
                    <QuesLoader show={phase === "showing-loader"} />
                    <form
                        ref={formRef}
                        className={
                            location.state.test.displayType === "3"
                                ? "flex_col g2"
                                : "flex_row flex_col_tablet g2"
                        }
                    >
                        <div className={`flex_col flex_gsb g2 shown ${phase}`}>
                            <div className="small-title">
                                {phrases?.["13106"]}
                            </div>
                            <div className="flex_col g2 align-items_center justify-content_center base p4 roundness_1 border_tt82 full-height">
                                {location.state.test.displayType !== "3" &&
                                    test.questions.map(
                                        (val, ind) =>
                                            val.questionText && (
                                                <div
                                                    key={val.id}
                                                    className="questionText"
                                                    dangerouslySetInnerHTML={{
                                                        __html: val.questionText,
                                                    }}
                                                />
                                            )
                                    )}
                                {location.state.test.displayType !== "3" &&
                                    test.questions.map(
                                        (val, ind) =>
                                            val.questionImage && (
                                                <img
                                                    key={val.id}
                                                    src={buildMediaUrl(
                                                        val.questionImage
                                                    )}
                                                    alt="question-image"
                                                />
                                            )
                                    )}
                                {location.state.test.displayType !== "3" &&
                                    test.questions.map(
                                        (val, ind) =>
                                            val.media &&
                                            val.media.map((media, ind) => (
                                                <img
                                                    key={media.id}
                                                    src={buildMediaUrl(
                                                        media.url
                                                    )}
                                                    alt="question-image"
                                                />
                                            ))
                                    )}
                                {location.state.test.displayType === "3" && (
                                    <img
                                        src={buildMediaUrl(
                                            test.questions[0].questionImage
                                        )}
                                        alt="question-image"
                                    />
                                )}
                            </div>
                        </div>
                        <div className={`flex_col flex_gsb g2 shown ${phase}`}>
                            <div className="flex_row justify-content_between">
                                {isMultiChoice && (
                                    <div className="small-title">
                                        {phrases?.["15138"]}
                                    </div>
                                )}
                                {isOpenText && (
                                    <div className="small-title">
                                        {phrases?.["15770"]}
                                    </div>
                                )}
                            </div>
                            <div className="flex_col g2 base p4 roundness_1 border_tt82 full-height">
                                {location.state.test.displayType === "1" && (
                                    <fieldset
                                        aria-label="group-container"
                                        className="checkbox-group-container"
                                    >
                                        <div className="checkbox-group base">
                                            {isMultiChoice &&
                                                questionData?.answers?.map(
                                                    (val, ind) => (
                                                        <div
                                                            key={uuidv4()}
                                                            className="checkbox-container"
                                                        >
                                                            <input
                                                                id={`option ${test.startNumber} -
                                                            ${ind}`}
                                                                type="checkbox"
                                                                value={
                                                                    val.position
                                                                }
                                                                checked={
                                                                    val.selected
                                                                }
                                                                onClick={() =>
                                                                    changeMultiSelectedAns(
                                                                        val,
                                                                        ind
                                                                    )
                                                                }
                                                            />
                                                            <label
                                                                dangerouslySetInnerHTML={{
                                                                    __html: val.content,
                                                                }}
                                                                htmlFor={`option-${ind}`}
                                                            />
                                                        </div>
                                                    )
                                                )}
                                        </div>
                                    </fieldset>
                                )}

                                {isOpenText && (
                                    <input
                                        type="text"
                                        id="texta"
                                        onChange={handleChange}
                                        value={textanswer}
                                        onKeyDown={(e) => {
                                            e.stopPropagation();

                                            if (e.code === "Enter") {
                                                e.preventDefault();
                                                if (!qpopupData?.isOpen)
                                                    nextNavigate();
                                            }
                                        }}
                                    />
                                )}
                            </div>
                        </div>
                    </form>
                </div>
                <hr />
                <div className="flex_col_reverse_mobile flex_row align-items_center justify-content_between g2">
                    {test.lastPage ? (
                        location.state.warmUp ? (
                            <button
                                className="button-secondary text_uppercase full-width_mobile"
                                onClick={exitTest}
                                disabled={loading}
                            >
                                {" "}
                                {phrases?.["1000229"]}{" "}
                            </button>
                        ) : (
                            <div />
                        )
                    ) : (
                        <button
                            className="button-secondary text_uppercase full-width_mobile"
                            onClick={exitTest}
                            disabled={loading}
                        >
                            {location.state.warmUp
                                ? phrases?.["1000229"]
                                : phrases?.["1002190"]}
                        </button>
                    )}
                    <button
                        className="button-primary text_uppercase full-width_mobile"
                        onClick={nextNavigate}
                        disabled={disablednext || loading}
                    >
                        {test.lastPage
                            ? location.state.warmUp
                                ? rightAns
                                    ? phrases?.["1000252"]
                                    : phrases?.["10976"]
                                : phrases?.["15140"]
                            : phrases?.["10976"]}
                        <span className="material-icons right">
                            arrow_forward
                        </span>
                    </button>
                </div>
            </div>
            <CommonPopup
                popupData={popupData}
                closeAction={closePopUp}
                approveAction={approveAction}
                setterFun={setpopupData}
            />
            <QuestionCommonPopup
                popupData={qpopupData}
                approveAction={qapproveAction}
            />
        </>
    );
};

export default TestTaker70;
